import * as v from 'valibot';
import { type ValidateTravellerFormRequestParams } from '@contracts';

export type PrebookRequestParams = ValidateTravellerFormRequestParams;

// ============================================
// Prebook Response Types
// ============================================

/**
 * Schema for prebook response resource data
 */
export const PrebookResourceDataSchema = v.object({
  checkoutUrl: v.optional(v.string()),
  checkoutId: v.optional(v.string()),
  bookingId: v.optional(v.string()),
});

export type PrebookResourceData = v.InferOutput<typeof PrebookResourceDataSchema>;

/**
 * Schema for prebook response resource
 */
export const PrebookResourceSchema = v.object({
  data: PrebookResourceDataSchema,
});

export type PrebookResource = v.InferOutput<typeof PrebookResourceSchema>;

/**
 * Schema for prebook response
 */
export const PrebookResponseSchema = v.object({
  status: v.string(),
  data: v.object({
    resources: v.array(PrebookResourceSchema), // TODO: prebook contract needs to be improved
  }),
});

export type PrebookResponse = v.InferOutput<typeof PrebookResponseSchema>;
